import React, { useState, useEffect } from 'react';
import {Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Snackbar} from '@mui/material';
import Grid from "@mui/material/Grid";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";
import MenuItem from "@mui/material/MenuItem";
import {AxiosSyncDefaultRequest} from "../../../../components/default_request";
import server from "../../../../server";
import {useDispatch} from "react-redux";
import {RenderSelectField} from "../../../../components/renderField";

const EditFormDialog = ({ open, onClose, rowData, onSave }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        id: '',
        name: "",
        service_number: '',
        is_much: false,
        supplier: '',
        service_type: '',
        international: false,  //是否国际服务
        is_enable: true, // 是否启用  # 未实装

        description: '', // 前端或其他地方获取展示使用
        is_debug: false //# 是否测试用
    });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success', // 可以是 'error', 'warning', 'info', 'success'
    });
    const dispatch = useDispatch();
    const [supplier_options, setSupplierOptions] = useState([])
    const [service_type_options, setServiceTypeOptions] = useState([])
    const [code, setCode] = useState({})
    // 当rowData改变时，更新表单数据
    useEffect(() => {
        if (rowData) {
            let row_data = {}
            Object.entries(rowData).map(([key, value]) => {
                    if(key in formData){

                        if(key === "service_type" || key === "supplier"){
                            row_data[key] = value.id
                        }
                        else {
                            row_data[key] = value
                        }
                    }


            })
            setFormData(row_data);
        }
    }, [rowData]);

    const handleChange = (event) => {
        const { name, value } = event.target;

            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));

    };
    useEffect(() => {
        setLoading(true)
        const fetchSupplierData = async () => {
            try {
                await AxiosSyncDefaultRequest({
                    url: `${server.logistics_supplier_list}?page=0&size=100`,
                    method: 'GET',
                    success: (res) => {
                        let options = []
                        let code_options = {}
                        let rows = res.data.rows
                        for (const i in rows) {
                            options.push({id: rows[i].id, name: rows[i].name})
                            code_options[rows[i].id] = rows[i].code
                        }
                        setSupplierOptions(options)
                        setCode(code_options)
                    },
                    // fail: (error) => {
                    //     console.error('请求失败', error);
                    //     setData([])
                    //     setLoading(false)
                    // }
                });
            } catch (error) {
                console.error('请求异常', error);
            }
        };
        const fetchServiceTypeData = async () => {
            try {
                await AxiosSyncDefaultRequest({
                    url: `${server.service_type}`,
                    method: 'GET',
                    success: (res) => {
                        let options = []
                        let rows = res.data.results
                        for (const i in rows) {
                            options.push({id: rows[i].id, name: rows[i].name})
                        }
                        setServiceTypeOptions(options)
                    },
                    // fail: (error) => {
                    //     console.error('请求失败', error);
                    //     setData([])
                    //     setLoading(false)
                    // }
                });
            } catch (error) {
                console.error('请求异常', error);
            }
        };
        fetchSupplierData();
        fetchServiceTypeData();
    }, [dispatch]);
    const handleSave = async () => {
        setLoading(true);
        try {
            let form_data = JSON.parse(JSON.stringify(formData));
            delete form_data["id"];
            const result = await onSave(form_data, formData.id, 'PUT');
            if (result.status === true) {
                // 操作成功，显示成功消息
                setSnackbar({ open: true, message: '保存成功！', severity: 'success' });
            }
        } catch (error) {
            console.error("保存失败", error);
            // 操作失败，显示错误消息
            // setSnackbar({ open: true, message: '保存失败，请重试。', severity: 'error' });
        } finally {
            // setLoading(false);
            onClose(); // 保存操作完成后关闭对话框
        }
    };
    const handleFieldChange = (event, value, key, value_key) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value?value[value_key]:'',
        }));

    };
    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>编辑信息</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="name"
                                label="服务名"
                                type="text"
                                fullWidth
                                variant="standard"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="service_number"
                                label="服务号"
                                type="text"
                                fullWidth
                                variant="standard"
                                value={formData.service_number}
                                onChange={handleChange}
                                required
                            />

                        </Grid>
                        <Grid item xs={12} md={8}>
                            <RenderSelectField
                                margin="dense"
                                idAname="supplier"
                                label="物流商"
                                value={formData.supplier}
                                select_options={supplier_options}
                                v="id"
                                value_name="name"
                                onChangeHandler={(e, value) => handleFieldChange(e, value, "supplier", "id")}
                                sx={{width: 353}}
                                required
                            />

                        </Grid>
                        <Grid item xs={12} md={8}>
                            <RenderSelectField
                                idAname="service_type"
                                label="服务类型"
                                value={formData.service_type}
                                select_options={service_type_options}
                                v="id"
                                value_name="name"
                                onChangeHandler={(e, value) => handleFieldChange(e, value, "service_type", "id")}
                                sx={{width: 353}}
                                required
                            />

                        </Grid>
                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="description"
                                label="描述"
                                type="text"
                                fullWidth
                                variant="standard"
                                value={formData.description}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="is_much"
                                label="是否一票多件"
                                type="text"
                                fullWidth
                                select
                                variant="standard"
                                value={formData.is_much}
                                onChange={handleChange}
                            >
                                <MenuItem key="is_much_true" value={true}>
                                    是
                                </MenuItem>
                                <MenuItem key="is_specific_true" value={false}>
                                    否
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="international"
                                label="是否国际服务"
                                type="text"
                                fullWidth
                                select
                                variant="standard"
                                value={formData.international}
                                onChange={handleChange}
                            >
                                <MenuItem key="international_true" value={true}>
                                    是
                                </MenuItem>
                                <MenuItem key="international_false" value={false}>
                                    否
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="is_debug"
                                label="是否测试服务"
                                type="text"
                                fullWidth
                                select
                                variant="standard"
                                value={formData.is_debug}
                                onChange={handleChange}
                            >
                                <MenuItem key="is_debug_true" value={true}>
                                    是
                                </MenuItem>
                                <MenuItem key="is_debug_false" value={false}>
                                    否
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="is_enable"
                                label="是否启用"
                                type="text"
                                fullWidth
                                select
                                variant="standard"
                                value={formData.is_enable}
                                onChange={handleChange}
                            >
                                <MenuItem key="is_enable_true" value={true}>
                                    是
                                </MenuItem>
                                <MenuItem key="is_enable_false" value={false}>
                                    否
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <TextField
                                margin="dense"
                                name="is_show"
                                label="是否显示"
                                type="text"
                                fullWidth
                                select
                                variant="standard"
                                value={formData.is_show}
                                onChange={handleChange}
                            >
                                <MenuItem key="is_show_true" value={true}>
                                    是
                                </MenuItem>
                                <MenuItem key="is_show_false" value={false}>
                                    否
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>取消</Button>
                    <Button loading={loading} onClick={handleSave} variant={"contained"}>保存</Button>
                </DialogActions>
            </Dialog>

        </>
    );
};

export default EditFormDialog;
